// eslint-disable-next-line import/prefer-default-export
export const breakpoints = {
    xs: 0,
    sm: 760,
    md: 980,
    lg: 1220,
};
